module.exports = __webpack_public_path__ + "images/embed/gray_arrow_right.png";